module.exports = __webpack_public_path__ + "static/media/add_to_trip.f4ddf05b.svg";